module.exports = __webpack_public_path__ + "static/InnovationGraenaherbergid-6a2e026a52cfc381308d660e618b3d6b.png";